<template>
  <Modal v-model="model" sticky reset-drag-position :title="title" @on-cancel="cancel" footer-hide scrollable :mask="false" draggable width="600">
    <div v-if="'audit' == this.actionForHandler" style="width: 100%;padding-left:20px;margin-top: 15px;">
      <RadioGroup v-model="result" >
        <Radio label="2">通过，关闭工单</Radio>
        <Radio style="margin-left: 20px;" label="1">不通过，退回重新处理</Radio>
      </RadioGroup>
    </div>
    <div v-show="result == '1' && 'audit' == this.actionForHandler" style="width: 100%;padding-left:20px;margin-top: 10px;">
      <Input v-model="contentForRefuse" placeholder="请输入具体原因，未输入内容将默认保存:审核不通过，请重新处理" type="textarea" :autosize="{minRows: 5,maxRows: 100}"/>
    </div>
    <Input v-show="'reset' == this.actionForHandler" v-model="contentForRefuse" placeholder="请输入重置原因" type="textarea" :autosize="{minRows: 5,maxRows: 100}"/>
    <Checkbox v-show="'reset' == this.actionForHandler" v-model="isSecret" class="order_class" >私密回复</Checkbox>
    <div style="text-align: end;margin-top:10px">
      <Button type="primary" class="submit_btn" :disabled="isClick" @click="onOk()">确认</Button>
      <Button type="error"   class="cancel_btn" @click="cancel()">取消</Button>
    </div>
  </Modal>
</template>

<script>
  export default {
    name: "AuditAndResetPop",
    props: {
      showHandlerPop: Boolean,
      fromWhere:String,
      workOrderId:String,
      actionForHandler:String,
      orderFromWhere:String
    },
    data(){
      return {
        title:'',
        model:false,
        result:'2',
        contentForRefuse:'',
        isSecret:false,
        isClick:false,
      }
    },
    methods:{
      getFromWhereForParam:function(fromWhere){
        let newValue = '';
        if('telephoneScreen' == fromWhere){
          newValue = '电话弹屏';
        }else if('onlineInfo' == fromWhere){
          newValue = '在线客服';
        }else if('allWorkOrder' == fromWhere){
          let code = "";
          if(this.orderFromWhere){
            code = this.orderFromWhere.substring(0,3);
          }
          switch(code){
            case 'b_2':
              newValue = "工单管理=>所有工单";
              break;
            case 'b_3':
              newValue = "工单管理=>我的未完成工单";
              break;
            case 'b_4':
              newValue = "工单管理=>待我确认的工单";
              break;
            case 'b_5':
              newValue = "工单管理=>抄送给我的工单";
              break;
            case 'b_6':
              newValue = "工单管理=>我创建的工单";
              break;
            case 'b_7':
              newValue = "工单管理=>未分配的工单";
              break;
            case 'b_8':
              newValue = "工单管理=>已分配的工单";
              break;
            case 'b_9':
              newValue = "工单管理=>处理中的工单";
              break;
            case 'b_a':
              newValue = "工单管理=>暂停的工单";
              break;
            case 'b_b':
              newValue = "工单管理=>已完成的工单";
              break;
            case 'b_c':
              newValue = "工单管理=>已关闭的工单";
              break;
          }
        }
        if(!newValue){
          newValue = '跳转工单';
        }
        return newValue;
      },
      cancel:function(){
        this.$emit("closeHandlerPop",false,this.fromWhere);
      },
      onOk:function () {

        let journalType = this.getFromWhereForParam(this.fromWhere);
        let checkType = '0';
        let isSecret = '1';
        let contentForRefuse = this.contentForRefuse;
        if('audit' == this.actionForHandler && '1' == this.result && !contentForRefuse){
          contentForRefuse = "审核不通过，请重新处理";
        }
        if('reset' == this.actionForHandler && !contentForRefuse){
          this.$Modal.info({
            title:'提示',
            content:"请输入重置原因"
          });
          return false;
        }
        this.isClick = true;
        if('2' == this.result && 'audit' == this.actionForHandler){
          contentForRefuse = '';
        }
        let meanId = this.orderFromWhere+'5';
        if('reset' == this.actionForHandler){
          journalType = "工单管理=>重置工单";
          checkType = '1';
          isSecret = this.isSecret ? "1" : "0";
          meanId = this.orderFromWhere+'8';
        }else{
          journalType = journalType+"=>审核工单";
        }
        if(!this.orderFromWhere){
          meanId = '';
        }
        let param={
          journalType: journalType,
          menuId: meanId,
          id:this.workOrderId,
          checkType: checkType,
          isSecret: isSecret,
          checkState:this.result,
          reason:contentForRefuse,
        };
        let that = this;
        this.$http.post("workOrder/doExamine.json", param).then(function (res) {
          let result = res.data.flag;
          if (result != "666") {
            that.isClick = false;
            that.$Modal.info({
              title: '提示',
              content: res.data.msg
            });
            return false;
          }
          that.$Message.info("操作成功");
          that.isClick = false;
          that.$emit("closeHandlerPop",true,that.fromWhere);
        });
      },
    },
    watch:{
      showHandlerPop:function () {
        this.model=this.showHandlerPop;
        if(this.showHandlerPop){
          this.result='2';
          this.contentForRefuse='';
          this.isSecret=false;
          this.isClick=false;
          this.title = "审核工单";
          if('reset' == this.actionForHandler){
            this.title = "重置工单";
          }
        }
      }

    }
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/workOrder/AuditAndResetPop.vue